import { date, object } from 'yup';
import {
  stringValidation,
  cityValidation,
  zipValidation,
  mustBeWholeNumber,
} from 'src/services/validation';

const LeasedAssetSchema = object().shape({
  lessorName: stringValidation(),
  lessorAddr: stringValidation(),
  lessorCity: cityValidation(),
  lessorState: stringValidation(),
  lessorZip: zipValidation(),
  agreementNo: stringValidation(),
  descr: stringValidation(),
  quantity: mustBeWholeNumber(),
  dateOf: date().required('Required'),
  term: stringValidation(),
  costOf: mustBeWholeNumber(),
  annualRent: mustBeWholeNumber(),
});

export default LeasedAssetSchema;
